(() => {
  const root = window.Shopify?.routes?.root || '/';
  let cartBusy = false;
  let campaignTime = null;
  let campaignTick = 0;
  const campaignPeriod = 7 * 24 * 60 * 60 * 1000;
  function syncCampaignTime(epoch) {
    if (Number.isFinite(epoch)) campaignTime = { epoch, tick: performance.now() };
  }
  function renderCampaignClocks() {
    if (!campaignTime) return;
    const now = campaignTime.epoch + performance.now() - campaignTime.tick;
    document.querySelectorAll('vt-campaign-countdown').forEach(clock => {
      const start = Number(clock.dataset.vtStart) * 1000;
      const elapsed = Math.max(0, now - start);
      const seconds = Math.ceil((campaignPeriod - elapsed % campaignPeriod) / 1000);
      const values = { days: Math.floor(seconds / 86400), hours: Math.floor(seconds / 3600) % 24, minutes: Math.floor(seconds / 60) % 60, seconds: seconds % 60 };
      Object.entries(values).forEach(([key, value]) => {
        const node = clock.querySelector(`[data-vt-time="${key}"]`);
        const text = String(value).padStart(2, '0');
        if (node && node.textContent !== text) node.textContent = text;
      });
    });
  }
  class CampaignCountdown extends HTMLElement {
    connectedCallback() {
      if (!campaignTime) syncCampaignTime(Number(this.dataset.vtServer) * 1000);
      renderCampaignClocks();
      if (!campaignTick) campaignTick = setInterval(renderCampaignClocks, 1000);
    }
  }
  if (!customElements.get('vt-campaign-countdown')) customElements.define('vt-campaign-countdown', CampaignCountdown);
  function updateProgress(count) {
    document.querySelectorAll('vt-volume-progress').forEach(el => {
      el.dataset.count = String(count);
      const width = count >= 4 ? 100 : count === 3 ? 200 / 3 : count === 2 ? 100 / 3 : count === 1 ? 50 / 3 : 0;
      el.style.setProperty('--vt-volume-progress', `${width}%`);
      el.querySelector('[data-vt-count]').textContent = String(count);
      el.querySelector('[data-vt-unit]').textContent = count === 1 ? 'ITEM' : 'ITEMS';
      el.querySelector('[role=progressbar]').setAttribute('aria-valuenow', String(Math.min(count, 4)));
      el.querySelectorAll('[data-vt-tier]').forEach(step => step.classList.toggle('is-reached', count >= Number(step.dataset.vtTier)));
      el.querySelector('[data-vt-message]').textContent = count >= 4 ? 'QUAD UNLOCKED: EXTRA 20% OFF' : `ADD ${count < 2 ? 2 - count : 1} MORE ${count === 0 ? 'ITEMS' : 'ITEM'} FOR EXTRA ${count < 2 ? 10 : count === 2 ? 15 : 20}% OFF`;
    });
    document.querySelectorAll('[data-vt-fw-offer]').forEach(el => {
      el.dataset.count = String(count);
      const activeTier = count >= 4 ? 4 : count >= 3 ? 3 : count >= 2 ? 2 : 0;
      el.querySelectorAll('[data-vt-fw-tier]').forEach(tier => {
        const active = Number(tier.dataset.vtFwTier) === activeTier;
        tier.classList.toggle('vt-fw-2026__tier--featured', active);
        if (active) tier.setAttribute('aria-current', 'step');
        else tier.removeAttribute('aria-current');
      });
      const remaining = count < 2 ? 2 - count : 1;
      const percent = count < 2 ? 10 : count === 2 ? 15 : 20;
      const template = count >= 4 ? el.dataset.vtMessageMax : remaining === 1 ? el.dataset.vtMessageOne : el.dataset.vtMessageMany;
      const message = el.querySelector('[data-vt-fw-message]');
      if (message && template) message.textContent = template.replace('[count]', String(remaining)).replace('[percent]', String(percent));
    });
  }
  let currentCartCount = null;
  let cartRefreshTimer;
  let cartRefreshBusy = false;
  let cartRefreshQueued = false;

  function setCartCount(value) {
    const count = Number(value);
    if (!Number.isInteger(count) || count < 0) return;
    currentCartCount = count;
    updateProgress(count);
  }

  async function refreshCart() {
    if (cartRefreshBusy) {
      cartRefreshQueued = true;
      return;
    }
    cartRefreshBusy = true;
    try {
      const clockRequestStart = performance.now();
      const response = await fetch(root + 'cart.js', { headers: { Accept: 'application/json' }, cache: 'no-store' });
      if (!response.ok) return;
      const serverDate = Date.parse(response.headers.get('date') || '');
      if (Number.isFinite(serverDate)) {
        syncCampaignTime(serverDate + (performance.now() - clockRequestStart) / 2);
        renderCampaignClocks();
      }
      const cart = await response.json();
      if (!cartRefreshQueued) setCartCount(cart.item_count);
    } catch {
      return;
    } finally {
      cartRefreshBusy = false;
      if (cartRefreshQueued) {
        cartRefreshQueued = false;
        scheduleCartRefresh();
      }
    }
  }

  function scheduleCartRefresh() {
    clearTimeout(cartRefreshTimer);
    if (cartRefreshBusy) cartRefreshQueued = true;
    cartRefreshTimer = setTimeout(refreshCart, 80);
  }

  function cartRequestFinished(entries) {
    if (entries.some(entry => {
      try {
        const url = new URL(entry.name, location.origin);
        return url.origin === location.origin && /\/cart\/(add|change|update|clear)(?:\.js)?$/.test(url.pathname);
      } catch {
        return false;
      }
    })) scheduleCartRefresh();
  }

  if (typeof PerformanceObserver !== 'undefined' && PerformanceObserver.supportedEntryTypes?.includes('resource')) {
    const cartRequests = new PerformanceObserver(list => cartRequestFinished(list.getEntries()));
    cartRequests.observe({ type: 'resource' });
  }

  ['cart:updated', 'cart:change', 'cart:refresh', 'product:added'].forEach(name => {
    document.addEventListener(name, scheduleCartRefresh);
  });

  function watchRenderedCart() {
    const drawer = document.querySelector('cart-drawer');
    if (!drawer || drawer.dataset.vtVolumeWatching) return;
    drawer.dataset.vtVolumeWatching = 'true';
    const observer = new MutationObserver(() => {
      const marker = drawer.querySelector('[data-vt-cart-count]');
      if (marker && Number(marker.dataset.vtCartCount) !== currentCartCount) setCartCount(marker.dataset.vtCartCount);
    });
    observer.observe(drawer, { childList: true, subtree: true });
  }

  watchRenderedCart();
  refreshCart();
  document.addEventListener('shopify:section:load', () => {
    watchRenderedCart();
    scheduleCartRefresh();
  });
  window.addEventListener('pageshow', scheduleCartRefresh);
  window.addEventListener('focus', scheduleCartRefresh);
  document.addEventListener('visibilitychange', () => {
    if (!document.hidden) scheduleCartRefresh();
  });

  class VolumeProgress extends HTMLElement {
    connectedCallback() {
      updateProgress(currentCartCount ?? (Number(this.dataset.count) || 0));
    }
  }
  if (!customElements.get('vt-volume-progress')) customElements.define('vt-volume-progress', VolumeProgress);
  let activityState;
  class ProductActivity extends HTMLElement {
    connectedCallback() {
      clearTimeout(this.activityTimer);
      const count = this.querySelector('[data-vt-viewing-count]');
      if (!count) return;
      activityState ??= { value: 4 + Math.floor(Math.random() * 3), deadline: Date.now() + 7000 };
      const { value, deadline } = activityState;
      count.textContent = String(value - (Date.now() >= deadline ? 1 : 0));
      const remaining = deadline - Date.now();
      if (remaining > 0) {
        this.activityTimer = setTimeout(() => {
          count.textContent = String(value - 1);
        }, remaining);
      }
    }
    disconnectedCallback() { clearTimeout(this.activityTimer); }
  }
  if (!customElements.get('vt-product-activity')) customElements.define('vt-product-activity', ProductActivity);
  window.addEventListener('pagehide', () => {
    clearInterval(campaignTick);
    campaignTick = 0;
  });
  window.addEventListener('pageshow', () => {
    renderCampaignClocks();
    if (!campaignTick && document.querySelector('vt-campaign-countdown')) campaignTick = setInterval(renderCampaignClocks, 1000);
  });
  function selectVariant(card) {
    const option = card.querySelector('select').selectedOptions[0];
    card.querySelector('[data-vt-rec-price]').textContent = option.dataset.price;
    card.querySelector('[data-vt-rec-compare]').textContent = option.dataset.compare;
    const image = card.querySelector('img');
    if (image && option.dataset.image) { image.src = option.dataset.image; image.removeAttribute('srcset'); }
    const button = card.querySelector('[data-vt-rec-toggle]');
    button.textContent = option.dataset.key ? '✓ Added' : '+ Add';
    button.classList.toggle('is-added', Boolean(option.dataset.key));
  }
  document.addEventListener('change', event => {
    if (event.target.matches('[data-vt-rec-variant]')) selectVariant(event.target.closest('.vt-recommendations__card'));
  });
  document.addEventListener('click', async event => {
    const arrow = event.target.closest('[data-vt-rec-prev], [data-vt-rec-next]');
    if (arrow) { const track = arrow.closest('.vt-recommendations').querySelector('.vt-recommendations__track'); track.scrollBy({left:track.clientWidth * (arrow.hasAttribute('data-vt-rec-prev') ? -1 : 1),behavior:matchMedia('(prefers-reduced-motion:reduce)').matches?'instant':'smooth'}); return; }
    const button = event.target.closest('[data-vt-rec-toggle]');
    if (!button || cartBusy) return;
    event.preventDefault();
    const card = button.closest('.vt-recommendations__card'), option = card.querySelector('select').selectedOptions[0];
    const error = card.querySelector('[data-vt-rec-error]'), drawer = document.querySelector('cart-drawer');
    if (drawer.querySelector('[aria-busy=true], .loading')) return;
    cartBusy = true;
    button.disabled = true; button.textContent = 'Updating…'; error.hidden = true;
    const checkout = drawer.querySelector('[name="checkout"]');
    if (checkout) checkout.disabled = true;
    try {
      const removing = Boolean(option.dataset.key);
      const response = await fetch(`${root}cart/${removing ? 'change' : 'add'}.js`, {
        method:'POST',headers:{'Content-Type':'application/json',Accept:'application/json'},
        body:JSON.stringify({...(removing ? {id:option.dataset.key,quantity:0} : {items:[{id:option.value,quantity:1}]}),sections:['cart-drawer','cart-icon-bubble'],sections_url:location.pathname})
      });
      const data = await response.json();
      if (!response.ok || data.status >= 400) throw Error(data.description || data.message || 'Could not update your cart. Please try again.');
      if (typeof drawer.renderContents !== 'function' || !data.sections?.['cart-drawer']) {
        location.assign(`${root}cart`); return;
      }
      drawer.renderContents(data);
    } catch (e) {
      error.hidden = false; error.textContent = e.message || 'Could not update your cart. Please try again.';
      selectVariant(card);
    } finally {cartBusy = false;button.disabled = false;if (checkout?.isConnected) checkout.disabled = false;}
  });
  window.addEventListener('click', event => {
    if (cartBusy && event.target.closest('[name="checkout"]')) {event.preventDefault();event.stopImmediatePropagation();}
  },true);
})();

